module.exports = __webpack_public_path__ + "img/1005.f120653e.png";